import React from 'react';
import { cn } from '../../lib/utils';

/**
 * EditorialKicker — petit label en éditeur magazine au-dessus des titres.
 */
export const EditorialKicker = ({ children, className, color, ...props }) => (
  <div
    className={cn('editorial-kicker inline-flex items-center gap-1.5', className)}
    style={color ? { color } : undefined}
    {...props}
  >
    {children}
  </div>
);

export default EditorialKicker;
